import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  constant,
  countAccommodationAndExperienceByDay,
  countAdminPackageByItineraryType,
  dbDateFormat,
  displayDateFormat,
  filterSelectedChildDataForItineraryPackage,
  pluralize,
  prepareDataForCartFromItineraryPackage,
} from "../commonFunction";
import AccommodationOrExperienceCardView from "../AccommodationOrExperienceCardView";
import {
  clearToCart,
  setCustomerPackageCart,
  updateCustomerPackageChildSelectItem,
  updateToCart,
} from "../../../../redux/actions/actions";
import EmptyRowComponent from "../EmptyRowComponent";
import VerticalTabsScrollable from "../../VerticalTabsScrollable";
import Slider from "react-slider-modal";
// import HotelDetailsComponent from "../HotelDetailsComponent";

const DisplayAmount = ({ startDate, endDate, onBookNow }) => {
  const {
    customerPackageBeforeDiscountAmount,
    customerPackageAfterDiscountAmount,
    customerPackageDiscountPercentage,
  } = useSelector((state) => state.adminPackageCart);

  return (
    <div className="card border mt-3 bg-light sticky-top" style={{ top: 170 }}>
      <div className="card-body">
        {customerPackageDiscountPercentage > 0 && (
          <p className="fw-bold">
            <s className="text-muted">
              {constant.amountWithCurrency(customerPackageBeforeDiscountAmount)}
            </s>{" "}
            <small className="text-danger">
              {customerPackageDiscountPercentage}% OFF
            </small>
          </p>
        )}
        <h5 className="card-title fw-bold mb-0">
          {constant.amountWithCurrency(customerPackageAfterDiscountAmount)}
        </h5>
        <small>Excluding applicable taxes</small>
        <p className="card-text border-top mt-2">
          <span class="latoBlack">
            {displayDateFormat(startDate, "DD MMM")} -{" "}
            {displayDateFormat(endDate, "DD MMM")}{" "}
          </span>
        </p>
      </div>
      {onBookNow && (
        <button className="btn btn-block btn-primary" onClick={onBookNow}>
          Book Now
        </button>
      )}
    </div>
  );
};

const ItineraryComponent = ({
  DatesOfDay,
  packageData,
  itineraryDetails,
  defaultZoneval,
  guestCombination,
}) => {
  const convertedToArrayGuestCombination = JSON.parse(
    JSON.parse(guestCombination)
  );
  const dispatch = useDispatch();

  const { customerPackage, customerPackageDiscountPercentage } = useSelector(
    (state) => state.adminPackageCart
  );

  // const packageFoundCondition = !customerPackage.some((x) =>
  //   x.child.filter((x) => x.selected).some((y) => y.not_available)
  // );

  const packageFoundCondition = !customerPackage.some(
    (x) => x.child.length === 0
  );

  const [tabData, setTabData] = useState([]);
  const [sliderOpen, setSliderOpen] = useState(false);
  const [sliderMainIndex, setSliderMainIndex] = useState(null);

  useEffect(() => {
    dispatch(setCustomerPackageCart());
  }, []);

  useEffect(() => {
    const resultData = [];
    DatesOfDay &&
      DatesOfDay.length > 0 &&
      DatesOfDay.map((sequenceDate, indexData) => {
        let Accomodationinput = itineraryDetails.find(
          (y) =>
            dbDateFormat(y.range[0].startDate) <= dbDateFormat(sequenceDate) &&
            dbDateFormat(y.range[0].endDate) > dbDateFormat(sequenceDate)
        );
        let itineraryinput = itineraryDetails.find(
          (y) =>
            dbDateFormat(y.range[0].startDate) <= dbDateFormat(sequenceDate) &&
            dbDateFormat(y.range[0].endDate) >= dbDateFormat(sequenceDate)
        );

        const accommodationCount = countAccommodationAndExperienceByDay(
          customerPackage,
          sequenceDate,
          4
        );

        const landAndFerryCount = countAccommodationAndExperienceByDay(
          customerPackage,
          sequenceDate,
          2
        );
        const activityCount = countAccommodationAndExperienceByDay(
          customerPackage,
          sequenceDate,
          1
        );
        const ferryTransfer = countAccommodationAndExperienceByDay(
          customerPackage,
          sequenceDate,
          3
        );

        resultData.push({
          label: displayDateFormat(sequenceDate),

          content: (
            <div className="dayplan-wrapper" data-testid="day-plan-wrapper">
              {packageFoundCondition ? (
                <>
                  <div id={`dayplan${indexData}`} day={indexData}></div>
                  <div
                    className="dayplan-header gap-3 m-0"
                    style={{
                      top: 166,
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      paddingBottom: 10,
                      borderRadius: 0,
                    }}
                  >
                    <p className="dayplan-title">
                      Day {indexData + 1} - {itineraryinput?.Location.label}{" "}
                      {Accomodationinput?.Location.label !=
                        itineraryinput?.Location.label && (
                        <>{`${
                          Accomodationinput?.Location.label
                            ? ` - ${Accomodationinput?.Location.label}`
                            : ""
                        }`}</>
                      )}
                    </p>
                    <div className="day-plan-incusions-container justify-content-lg-end justify-content-md-evenly">
                      {[
                        {
                          color: "primary",
                          count: accommodationCount,
                          label: "Hotel",
                        },
                        {
                          color: "secondary",
                          count: landAndFerryCount,
                          label: "Transfer",
                        },
                        {
                          color: "info",
                          count: ferryTransfer,
                          label: "Ferry Transfer",
                        },
                        {
                          color: "success",
                          count: activityCount,
                          label: "Activity",
                        },
                      ].map(({ color, count, label }, i) => (
                        <span
                          key={`count-${i}`}
                          className={`badge bg-${color} me-2`}
                          style={{ minWidth: "70px" }}
                        >{`${count} ${pluralize(label, count)}`}</span>
                      ))}
                    </div>
                  </div>

                  {customerPackage.length > 0 ? (
                    customerPackage.map(
                      ({ child, itinerary_type }, mainIndex) => {
                        const newChild = child.filter(
                          ({ start_date, end_date }) =>
                            itinerary_type === 4
                              ? dbDateFormat(start_date) <=
                                  dbDateFormat(sequenceDate) &&
                                dbDateFormat(end_date) >
                                  dbDateFormat(sequenceDate)
                              : dbDateFormat(new Date(start_date)) ===
                                dbDateFormat(sequenceDate)
                        );

                        if (newChild.length === 0) return null;

                        const childIndex = newChild.findIndex(
                          (x) => x.selected
                        );
                        const {
                          image,
                          name,
                          address,
                          start_date,
                          end_date,
                          checkIn,
                          checkOut,
                          roomName,
                          guestCombinationMatrix,
                          inclusions,
                          meals,
                          price,
                          option_name,
                          experience_time,
                          selected,
                          not_available,
                          hotelData,
                        } = newChild[childIndex];

                        return (
                          <div
                            className="container my-4"
                            key={`package-${mainIndex}`}
                          >
                            <div className="col-md-12 p-2">
                              <AccommodationOrExperienceCardView
                                horizontal
                                notAvailable={not_available}
                                key={`package-${mainIndex}-${childIndex}`}
                                show={
                                  selected &&
                                  (itinerary_type === 4
                                    ? dbDateFormat(start_date) <=
                                        dbDateFormat(sequenceDate) &&
                                      dbDateFormat(end_date) >
                                        dbDateFormat(sequenceDate)
                                    : dbDateFormat(new Date(start_date)) ===
                                      dbDateFormat(sequenceDate))
                                }
                                type={
                                  itinerary_type === 4
                                    ? "Accommodation"
                                    : itinerary_type === 2
                                    ? "Land Transfer"
                                    : itinerary_type === 3
                                    ? "Ferry Transfer"
                                    : itinerary_type === 1
                                    ? "Activity"
                                    : ""
                                }
                                imageSrc={image}
                                propertyName={name}
                                address={itinerary_type === 4 ? address : ""}
                                checkIn={
                                  itinerary_type === 4 &&
                                  `${displayDateFormat(start_date)}, ${checkIn}`
                                }
                                checkOut={
                                  itinerary_type === 4 &&
                                  `${displayDateFormat(end_date)}, ${checkOut}`
                                }
                                date={
                                  itinerary_type !== 4 &&
                                  `${displayDateFormat(start_date)}${
                                    experience_time
                                      ? `, ${experience_time}`
                                      : ", Cordinate Time"
                                  }`
                                }
                                // roomRatePlan={itinerary_type !== 4 ? option_name : ""}
                                optionName={option_name}
                                roomName={roomName}
                                guestCombinationMatrix={guestCombinationMatrix}
                                meals={meals}
                                inclusions={inclusions}
                                // price={price}
                                onEdit={
                                  newChild.length > 1
                                    ? () => {
                                        setSliderMainIndex(mainIndex);
                                        onOpenSlider();
                                      }
                                    : undefined
                                }
                                // modalComponent={
                                //   itinerary_type === 4 ? (
                                //     <HotelDetailsComponent hotelData={hotelData} />
                                //   ) : (
                                //     <></>
                                //   )
                                // }
                              />
                            </div>
                          </div>
                        );
                      }
                    )
                  ) : (
                    <EmptyRowComponent />
                  )}
                </>
              ) : (
                <EmptyRowComponent />
              )}
            </div>
          ),
        });
      });
    setTabData(resultData);
  }, [DatesOfDay, packageData, customerPackage]);

  const onCloseSlider = () => setSliderOpen(false);
  const onOpenSlider = () => setSliderOpen(true);

  const redirectToReview = () => {
    const findSelectedData = filterSelectedChildDataForItineraryPackage(
      customerPackage
    );

    const prepareDataForCart = prepareDataForCartFromItineraryPackage(
      findSelectedData,
      customerPackageDiscountPercentage,
      convertedToArrayGuestCombination,
      defaultZoneval
    );

    dispatch(clearToCart());
    dispatch(updateToCart(prepareDataForCart));
    window.location.href = "/paymentcart";
  };

  return (
    <>
      {/* {!sliderOpen && ( */}
      <div className="container-fluid">
        <div
          className="row px-1 py-2 bg-light align-items-center position-sticky"
          style={{ top: 118, zIndex: 1 }}
        >
          <div className="col text-center">
            <div className="border border-primary rounded-pill py-1 px-3 bg-white text-uppercase fw-bold">
              {DatesOfDay.length} Day Itinerary
            </div>
          </div>
          {[
            {
              label: "Hotel",
              count: countAdminPackageByItineraryType(customerPackage, 4),
            },
            {
              label: "Transfer",
              count: countAdminPackageByItineraryType(customerPackage, 2),
            },
            {
              label: "Ferry Transfer",
              count: countAdminPackageByItineraryType(customerPackage, 3),
            },
            {
              label: "Activity",
              count: countAdminPackageByItineraryType(customerPackage, 1),
            },
          ].map(({ label, count }, i, arr) => (
            <div
              key={`overall-count-${i}`}
              className={`col text-center${
                i !== arr.length - 1 ? " border-end" : ""
              }`}
            >
              <span className="fw-bold">{count}</span>
              {"  "}
              {pluralize(label, count)}
            </div>
          ))}
        </div>
        <div className="row">
          <div className="col-md-9">
            {tabData.length > 0 && (
              <VerticalTabsScrollable
                tabs={tabData}
                pointerListTitleStyle={{ top: 170 }}
                pointerListStyle={{ top: 210 }}
              />
            )}
          </div>
          <div className="col-md-3">
            {packageFoundCondition && (
              <DisplayAmount
                startDate={DatesOfDay[0]}
                endDate={DatesOfDay[DatesOfDay.length - 1]}
                onBookNow={redirectToReview}
              />
              // ) : (
              //   <p className="text-danger">
              //     The itinerary may not be available. To proceed, please update
              //     its availability.
              //   </p>
            )}
          </div>
        </div>
      </div>
      {/* )} */}
      <Slider
        id="change-itinerary"
        // animation="zoom"
        speed="fast"
        closeIcon={onCloseSlider}
        outSideClose={onCloseSlider}
        closeModal={onCloseSlider}
        toggle={sliderOpen}
        sliderStyle={{
          width: "80%",
          height: "100%",
          top: "0px",
          overflowY: "scroll",
          zIndex: 9999,
        }}
        direction="right"
        render={
          customerPackage[sliderMainIndex]?.child?.length > 0 ? (
            customerPackage[sliderMainIndex].child.map(
              (
                {
                  image,
                  name,
                  address,
                  start_date,
                  end_date,
                  checkIn,
                  checkOut,
                  roomName,
                  guestCombinationMatrix,
                  inclusions,
                  meals,
                  price,
                  option_name,
                  experience_time,
                  itinerary_type,
                  selected,
                },
                childIndex,
                childArray
              ) => {
                const givenPrice = parseFloat(
                  childArray.find((x) => x.selected).price
                );
                const currentPrice = parseFloat(price);
                const differentPrice = (currentPrice - givenPrice).toFixed(2);

                return (
                  <div
                    className="container my-4"
                    key={`package-slider-${childIndex}`}
                  >
                    <div className="col-md-12 p-2">
                      <AccommodationOrExperienceCardView
                        horizontal
                        show={true}
                        type={
                          itinerary_type === 4
                            ? "Accommodation"
                            : itinerary_type === 2
                            ? "Land Transfer"
                            : itinerary_type === 3
                            ? "Ferry Transfer"
                            : itinerary_type === 1
                            ? "Activity"
                            : ""
                        }
                        imageSrc={image}
                        propertyName={name}
                        address={address}
                        checkIn={
                          itinerary_type === 4 &&
                          `${displayDateFormat(start_date)}, ${checkIn}`
                        }
                        checkOut={
                          itinerary_type === 4 &&
                          `${displayDateFormat(end_date)}, ${checkOut}`
                        }
                        date={
                          itinerary_type !== 4 &&
                          `${displayDateFormat(start_date)}${
                            experience_time
                              ? experience_time
                              : ", Cordinate Time"
                          }`
                        }
                        // roomRatePlan={itinerary_type !== 4 ? option_name : ""}
                        optionName={option_name}
                        roomName={roomName}
                        guestCombinationMatrix={guestCombinationMatrix}
                        meals={meals}
                        inclusions={inclusions}
                        price={
                          !selected && (
                            <span
                              className={`text-${
                                differentPrice > 0 ? "danger" : "success"
                              }`}
                            >{` ${
                              differentPrice >= 0 ? "+" : ""
                            }${differentPrice}`}</span>
                          )
                        }
                        selectedIndex={selected}
                        onSelect={() => {
                          dispatch(
                            updateCustomerPackageChildSelectItem(
                              sliderMainIndex,
                              childIndex
                            )
                          );
                          onCloseSlider();
                        }}
                      />
                    </div>
                  </div>
                );
              }
            )
          ) : (
            <EmptyRowComponent />
          )
        }
      />
    </>
  );
};

export default ItineraryComponent;
